import { Component, signal } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NavbarComponent } from "./navbar/navbar.component";
import { ToastModule } from "primeng/toast";
import { LoadingSpinnerComponent } from "./shared/components/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-root",
  imports: [
    RouterOutlet,
    NavbarComponent,
    ToastModule,
    LoadingSpinnerComponent,
  ],
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
})
export class App {
  protected readonly title = signal("admin-panel");
}
